"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleImagePreview = void 0;
/* eslint-disable no-underscore-dangle */
const core_1 = require("@angular/core");
const file_service_1 = require("../../../../../shared/storage/file.service");
let VehicleImagePreview = class VehicleImagePreview {
    constructor(fileService) {
        this.fileService = fileService;
        this.previousVehicle = '';
        this.previewUrl = null;
        this.setImage = () => {
            var _a;
            if (!((_a = this.vehicle.vehicleData.images) === null || _a === void 0 ? void 0 : _a.length))
                return;
            this.previewUrl = this.fileService.getStaticUrl(this.vehicle.vehicleData.images[0], { width: '400' });
        };
    }
    ngOnInit() {
        this.setImage();
        this.previousVehicle = String(this.vehicle._id);
    }
    /** When table gets filtered, the same component is reused
     * but the vehicle supplied gets changed. So we need to update
     * the image in this case. */
    ngOnChanges() {
        if (String(this.vehicle._id) === this.previousVehicle)
            return;
        this.previousVehicle = String(this.vehicle._id);
        this.setImage();
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleImagePreview.prototype, "vehicle", void 0);
VehicleImagePreview = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-image-preview',
        template: `
    <div *ngIf="vehicle.vehicleData.images?.length" class="image-preview">
      <i class="fa-light fa-images"></i>
      <span class="image-count">{{ vehicle.vehicleData.images.length }}</span>

      <div class="image-preview-container" *ngIf="previewUrl">
        <!-- <static-resource [staticId]="vehicle.vehicleData.images[0]"></static-resource> -->
        <img [src]="previewUrl" loading="lazy">
      </div>
    </div>
  `,
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof file_service_1.FileService !== "undefined" && file_service_1.FileService) === "function" ? _a : Object])
], VehicleImagePreview);
exports.VehicleImagePreview = VehicleImagePreview;
